import { render, staticRenderFns } from "./EditConfigModal.vue?vue&type=template&id=068a9a97&scoped=true&"
import script from "./EditConfigModal.vue?vue&type=script&lang=js&"
export * from "./EditConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./EditConfigModal.vue?vue&type=style&index=0&id=068a9a97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a9a97",
  null
  
)

export default component.exports